import * as yup from 'yup';
import type { PnlDimensionHierarchy } from 'src/components/star-grid/pnlDimension.types';

const optionalText = () => yup.string().min(1).nullable().optional();
const hierarchySchema = yup
  .array()
  .of(
    yup
      .object({
        hierarchy: yup.string().min(1).optional(),
        binding_id: optionalText(),
        hierarchy_id: optionalText(),
        label: optionalText(),
        fact_key: optionalText(),
        cdp_hierarchy: yup.string().min(1).optional(),
        attribute: optionalText()
      })
      .required()
      .test('hierarchy-reference', 'Missing hierarchy identity', (value) =>
        Boolean(value?.hierarchy || (value?.hierarchy_id && value?.label && value?.fact_key))
      )
  )
  .required();

export const parsePnlDimensionHierarchies = async (value: unknown): Promise<PnlDimensionHierarchy[]> => {
  const hierarchies = await hierarchySchema.validate(value, { strict: true });
  return hierarchies.map((option) => ({ ...option, cdp_hierarchy: option.cdp_hierarchy ?? option.hierarchy }));
};
